import { CandidateInterviewResult } from "@relode/core";
import { candidates } from "../controllers";

export const convertCandidateInterviewRequest = (
    data: CandidateInterviewResult,
    candidateConcurrencyToken: string
): candidates.CandidateInterviewRequest => {
    const interview: candidates.CandidateInterviewRequest = {
        candidateInterviewId: data.candidateInterviewId,
        interviewStatusTypeId: data.interviewStatusTypeId,
        interviewTypeId: data.interviewTypeId,
        interviewDate: data.interviewDate,
        interviewTime: data.interviewTime,
        durationHours: data.durationHours,
        durationMinutes: data.durationMinutes,
        timeZoneId: data.timeZoneId,
        candidateConcurrencyToken: candidateConcurrencyToken,
        interviewDetails: data.interviewDetails,
        sendNotification: data.sendNotification
    };
    return interview;
};
